/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  SaveButton,
  FileInput as RaFileInput,
  ImageInput as RaImageInput,
  SimpleForm,
  Confirm,
  ImageField,
  ChipField,
  FunctionField,
  Toolbar,
  FileField,
  required,
} from 'react-admin'
import { PRODUCTS_COMMON_FIELDS } from '../../providers/localization/constant'
import { ListActions } from '../../components/list-actions'
import { useCallback, useState } from 'react'

import { useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { FileRejection, DropEvent } from 'react-dropzone'

import { Card } from '@mui/material'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

import UploadProgressDialog from '../../components/Dialog/UploadProgressDialog'
import { useImportProduct } from '../../hooks/useImportProduct'
import _ from 'lodash'
import { ImageGridImage } from '../../components/image-grid'

// eslint-disable-next-line no-unused-vars
type OnDropRejected = (fileRejections: FileRejection[], event: DropEvent) => void

const FileInput = ({ source, ...props }): JSX.Element => {
  const { setError, getValues, setValue, clearErrors } = useFormContext()

  const handleDropRejected: OnDropRejected = useCallback((fileRejections, event) => {
    const rejectedFileGroup = _(fileRejections)
      .groupBy('errors[0].code')
      .mapValues((value) => {
        const fileNames = _.map(value, (obj) => `[ ${_.get(obj, 'file.name')} ]`).join(' ,')
        return `${_.get(_.first(value), 'errors[0].message')}: ${fileNames}`
      })
      .value()

    /*
     * Set the touch of fieldState to true to display the error message on RaImageInput.
     */
    setValue(source, getValues(source), { shouldTouch: true })
    setError(source, { type: 'validate', message: _.values(rejectedFileGroup).join(' - ') })
  }, [])

  const handleDrop = useCallback(() => {
    clearErrors(source)
  }, [])

  return (
    <RaFileInput
      source={source}
      options={{ onDropRejected: handleDropRejected, onDrop: handleDrop }}
      {...props}
    >
      <FileField source='src' title='title' />
    </RaFileInput>
  )
}

const ImageInput = ({ source, ...props }): JSX.Element => {
  const { setError, getValues, setValue, clearErrors } = useFormContext()

  const handleDropRejected: OnDropRejected = useCallback((fileRejections, event) => {
    const rejectedFileGroup = _(fileRejections)
      .groupBy('errors[0].code')
      .mapValues((value) => {
        const fileNames = _.map(value, (obj) => `[ ${_.get(obj, 'file.name')} ]`).join(' ,')
        return `${_.get(_.first(value), 'errors[0].message')}: ${fileNames}`
      })
      .value()

    /*
     * Set the touch of fieldState to true to display the error message on RaImageInput.
     */
    setValue(source, getValues(source), { shouldTouch: true })
    setError(source, { type: 'validate', message: _.values(rejectedFileGroup).join(' - ') })
  }, [])

  const handleDrop = useCallback(() => {
    clearErrors(source)
  }, [])

  return (
    <RaImageInput
      source={source}
      options={{ onDropRejected: handleDropRejected, onDrop: handleDrop }}
      {...props}
    >
      {props.children}
    </RaImageInput>
  )
}

const ImportProduct = (): JSX.Element => {
  const [open, setOpen] = useState(false)
  const [temp, setTemp] = useState({})

  const { productType } = useParams()

  const { handleClose, handleSubmit, loading, progressDialog, progress, importResultLists } =
    useImportProduct({
      productType,
    })

  const PostCreateToolbar = useCallback(({ isLoading }: { isLoading: boolean }) => {
    return (
      <Toolbar>
        <SaveButton label={`${PRODUCTS_COMMON_FIELDS}.import.title`} disabled={isLoading} />
      </Toolbar>
    )
  }, [])

  const _handleSubmit = (e): void => {
    setOpen(true)
    setTemp(e)
  }

  const handleConfirm = (): void => {
    setOpen(false)
    handleSubmit(temp)
    setTemp({})
  }

  const handleDialogClose = (): void => {
    setOpen(false)
  }

  return (
    <>
      <Confirm
        isOpen={open}
        loading={loading}
        title={`${PRODUCTS_COMMON_FIELDS}.import.title`}
        content={`${PRODUCTS_COMMON_FIELDS}.import.title`}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
      <ListActions hasCreate={false} hasExport={false} filters={[]} />
      <Card style={{ padding: 16 }}>
        <SimpleForm onSubmit={_handleSubmit} toolbar={<PostCreateToolbar isLoading={loading} />}>
          <FileInput source={'csv'} accept='.csv' label='CSV' />
          <ImageInput source='images' accept='image/*' label='Images' multiple maxSize={10000000}>
            <FunctionField
              label='Name'
              render={(): JSX.Element => {
                return (
                  <Box
                    sx={{
                      p: 1,
                      bgcolor: 'background.paper',
                      // width: 120,
                      // height: 120,
                      // objectFit: 'cover',
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    alignItems={'center'}
                  >
                    {/* <ImageGridImage source='src' title='title' /> */}
                    <ChipField source='title' />
                  </Box>
                )
              }}
            />
          </ImageInput>
        </SimpleForm>
        <UploadProgressDialog
          open={progressDialog}
          progress={progress}
          handleClose={handleClose}
          importResultLists={importResultLists}
        />
      </Card>
    </>
  )
}

export default ImportProduct
